import { getAds } from '../../services/ads'
import * as types from '../types'

export const searchAds = async (searchOptions, dispatch) => {
  dispatch({ type: types.CHANGE_SEARCH, payload: searchOptions })
  const ads = await getAds(searchOptions)
  if (ads) dispatch({ type: types.FETCH_ADS, payload: ads })
}
